import { formatNumberToKMB } from 'utils/common';

const getTooltipRow = (header, value, colorOfValue = '#929292') =>
    '<div><span style="line-height: 30px;">' +
    header +
    '</span>' +
    `<span style="font-weight: 400; margin-left: 8px; color: ${colorOfValue};">` +
    value +
    '</span></div>';

export const tooltipForRMLevel = (outliers) => {
    return {
        trigger: 'item',
        formatter: function (params) {
            const { name: ctoCode, value, componentType } = params;
            if (componentType === 'series') {
                const pnl = value[0];
                const commOrRevenue = value[1];
                const colorForPnL = pnl > 0 ? '#15C988' : '#EB4560';
                const rm = outliers.find((o) => o.rmEmployeeId === ctoCode);

                return (
                    getTooltipRow('CTO Code', ctoCode) +
                    getTooltipRow('Team', rm.rmGroup) +
                    getTooltipRow('Market', rm.rmRegion) +
                    getTooltipRow('S1 Rank', rm.rank) +
                    getTooltipRow('S1 Risk Score', rm.score) +
                    getTooltipRow(
                        'RM Revenue',
                        `$${formatNumberToKMB(commOrRevenue)}`
                    ) +
                    getTooltipRow(
                        'Portfolio Unrealized PnL',
                        `$${formatNumberToKMB(pnl)}`,
                        colorForPnL
                    )
                );
            }
        },
        textStyle: {
            color: '#000000',
            fontWeight: 700,
            fontSize: '10px'
        },
        position: 'right',
        extraCssText:
            'box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08); ' +
            'border: 1px solid white; ' +
            'border-radius: 16px; ' +
            'padding: 16px;'
    };
};

export const tooltipForPortfolioLevel = (portfolios, outlier) => {
    return {
        formatter: function (params) {
            const { name: portfolioId, value } = params;
            const pnl = value[0];
            const commOrRevenue = value[1];
            const colorForPnL = pnl > 0 ? '#15C988' : '#EB4560';
            const portfolio = portfolios.find(
                (o) => o.portfolioId === portfolioId
            );

            return (
                getTooltipRow('Portfolio Number', portfolioId) +
                getTooltipRow('CTO Code', portfolio.rm) +
                getTooltipRow('Team', outlier && outlier.rmGroup) +
                getTooltipRow('Market', outlier && outlier.rmRegion) +
                getTooltipRow(
                    'RM Revenue',
                    `$${formatNumberToKMB(commOrRevenue)}`
                ) +
                getTooltipRow(
                    'Portfolio Unrealized PnL',
                    `$${formatNumberToKMB(pnl)}`,
                    colorForPnL
                )
            );
        },
        textStyle: {
            color: '#000000',
            fontWeight: 700,
            fontSize: '10px'
        },
        position: 'right',
        extraCssText:
            'box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08); ' +
            'border: 1px solid white; ' +
            'border-radius: 16px; ' +
            'padding: 16px;'
    };
};

export const getHighestAndInterval = (highest, intervalCount) => {
    if (Math.abs(highest) === Infinity) {
        return {
            roundedHighest: 100000,
            interval: 100000 / intervalCount,
            digit: 'K'
        };
    }

    const numDigits = Math.ceil(highest).toString().length;
    const roundedHighest =
        Math.ceil(highest / Math.pow(10, numDigits - 1)) *
        Math.pow(10, numDigits - 1);

    return {
        roundedHighest,
        interval: roundedHighest / intervalCount,
        digit: numDigits > 10 ? 'B' : numDigits > 7 ? 'M' : 'K'
    };
};

export const axisLabelFormatter = (value, digit, showZero) => {
    if (value === 0) {
        if (showZero) return value;
        return;
    }

    if (value < 1000 && value > -1000) {
        return value;
    }

    if (digit === 'B')
        return `$${(value - (value % 1000000000)) / 1000000000}B`;
    if (digit === 'M') return `$${(value - (value % 1000000)) / 1000000}M`;
    return `$${(value - (value % 1000)) / 1000}k`;
};
